import { render, staticRenderFns } from "./formMoney.vue?vue&type=template&id=18adb6ae&scoped=true"
import script from "./formMoney.vue?vue&type=script&lang=js"
export * from "./formMoney.vue?vue&type=script&lang=js"
import style0 from "./formMoney.vue?vue&type=style&index=0&id=18adb6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18adb6ae",
  null
  
)

export default component.exports